import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'
import ContentLoader from 'react-content-loader'

const OrderPageLoader = () => {
  return (
    <Container>
      <ContentLoader speed={2}>
        <rect x='0' y='0' width='100%' height='50%' border-radius='6px' />
        <rect x='0' y='52%' width='100%' height='40%' border-radius='6px' />
        <rect x='0' y='84%' width='100%' height='50%' border-radius='6px' />
      </ContentLoader>
    </Container>
  )
}

const Container = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  minHeight: '95vh',
  justifyContent: 'center',

  // viewport padding and widths to match Order.tsx
  [theme.mediaQueries.viewport5]: {
    padding: '40px 0', // remove left/right padding so animation fits to edge
    width: '664px', // content width of Order
    margin: 'auto'
  },

  [theme.mediaQueries.viewport12]: {
    padding: '32px 0' // remove left/right padding so animation fits to edge
  },

  '& svg': {
    borderRadius: theme.borderRadius
  }
}))

export default OrderPageLoader
